import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type TimeAdjustmentsInput,
  timeAdjustmentsInputSchema,
} from "./shared/timeAdjustments.input";
import {
  type TimeAdjustment,
  timeAdjustmentSchema,
} from "./shared/timeAdjustments.output";

/**
 * Metadata for the fetchTimeAdjustments endpoint
 */
export const timeAdjustmentsMeta = {
  functionName: "fetchTimeAdjustments",
  endpoint: "/timeadj",
  inputSchema: timeAdjustmentsInputSchema,
  outputSchema: timeAdjustmentSchema.array(),
  sampleParams: {},
  endpointDescription: "List all time adjustments across all routes.",
} satisfies EndpointMeta<TimeAdjustmentsInput, TimeAdjustment[]>;

const { fetch, useHook } = createFetchAndHook<
  TimeAdjustmentsInput,
  TimeAdjustment[]
>({
  api: wsfScheduleApiMeta,
  endpoint: timeAdjustmentsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/timeAdjustments.endpoints").timeAdjustmentsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all time adjustments across all routes
 */
export const fetchTimeAdjustments: FetchFactory<
  TimeAdjustmentsInput,
  TimeAdjustment[]
> = fetch;

/**
 * React Query hook for retrieving all time adjustments across all routes
 */
export const useTimeAdjustments: HookFactory<
  TimeAdjustmentsInput,
  TimeAdjustment[]
> = useHook;
